import { Injectable, Type } from '@angular/core';
import { DefaultDashboardLayoutComponent } from '../../dashboard/components/default-dashboard-layout/default-dashboard-layout.component';

@Injectable({
  providedIn: 'root',
})
export class ViewControllerProviderService {
  constructor() {}

  public provide(app: number, view: any): Type<any> {
    // TODO esta función deberá proveer los componentes para las vistas del sistema
    // Se aparta dashboard por ser la unica disponible
    if (view === 'dashboard') {
      return DefaultDashboardLayoutComponent;
    }
    return DefaultDashboardLayoutComponent;
  }
}
